import { SelectionColours } from "./selection-colors";

export const INITIAL_COLOR_OPTIONS = {
  aqua: {
    title: "Aqua",
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.AQUA],
    },
  },
  black: {
    title: "Black",
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.BLACK],
    },
  },
  blue: {
    title: "Blue",
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.BLUE],
    },
  },
  orange: {
    title: "Orange",
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.ORANGE],
    },
  },
  darkOrange: {
    title: "Dark Orange",
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.DARK_ORANGE],
    },
  },
  red: {
    title: "Red",
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.RED],
    },
  },
  sand: {
    title: "Sand",
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.SAND],
    },
  },
  yellow: {
    title: "Yellow",
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.YELLOW],
    },
  },
  white: {
    title: "White",
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.WHITE],
    },
  },
};
